export default [
  {
    text: 'Vendor/Contractor Number',
    value: 'number',
    order: 0,
    sortable: true,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Company Name',
    value: 'companyName',
    align: 'left',
    sortable: false,
    order: 2,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Address',
    value: 'address.line1',
    align: 'left',
    sortable: true,
    order: 3,
    hidable: true,
    hidden: false,
  },

  {
    text: 'Country',
    value: 'address.country',
    order: 6,
    hidable: true,
    hidden: true,
  },
  {
    text: 'Telephone',
    value: 'phoneNumber',
    order: 7,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Email',
    value: 'email',
    order: 8,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Actions',
    value: 'actions',
    align: 'right',
    sortable: false,
    order: 8,
    hidable: true,
    hidden: false,
    width: '92px',
  },
];
